/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DanceDetail } from './DanceDetail';
import {
    DanceDetailFromJSON,
    DanceDetailFromJSONTyped,
    DanceDetailToJSON,
    DanceDetailToJSONTyped,
} from './DanceDetail';

/**
 * 
 * @export
 * @interface ResultOfDanceDetail
 */
export interface ResultOfDanceDetail {
    /**
     * 
     * @type {DanceDetail}
     * @memberof ResultOfDanceDetail
     */
    data: DanceDetail | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfDanceDetail
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfDanceDetail
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfDanceDetail interface.
 */
export function instanceOfResultOfDanceDetail(value: object): value is ResultOfDanceDetail {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfDanceDetailFromJSON(json: any): ResultOfDanceDetail {
    return ResultOfDanceDetailFromJSONTyped(json, false);
}

export function ResultOfDanceDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfDanceDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'data': DanceDetailFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfDanceDetailToJSON(json: any): ResultOfDanceDetail {
    return ResultOfDanceDetailToJSONTyped(json, false);
}

export function ResultOfDanceDetailToJSONTyped(value?: ResultOfDanceDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': DanceDetailToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

